// TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B.
//
// Route constants for the internal-only RA Session Review page. Deliberately
// NOT in projectsRoutesConstants.ts: this page is explicitly never nested
// under /projects/:id (RA sessions span projects and orgs by design — see
// docs/research-assistant/OR-6432-session-observability-spike.md), so it
// doesn't belong with the project-scoped route constants.

import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

export const RA_SESSION_REVIEW_BASE_PATH = EvidencePlatformSidebarAppID.raSessionReview;

export const getRaSessionReviewBasePath = () => {
  return `/${RA_SESSION_REVIEW_BASE_PATH}`;
};
